import * as React from "react";

const CaskOrderPage: React.FC<{ children?: React.ReactNode }> = (props) => (
  <div>{props.children}</div>
);

export default CaskOrderPage;
